import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Eye } from "lucide-react";

export function PublicPreviewButton({ businessId, dirty, onSave }) {
  const [ask, setAsk] = useState(false);
  const url = `/maestro/${businessId}`;
  const open = () => window.open(url, "_blank", "noopener");
  const saveAndView = async () => {
    const tab = window.open("about:blank", "_blank");
    const ok = await onSave();
    if (ok && tab) tab.location.href = url;
    else tab?.close();
  };
  return (
    <>
      <Button type="button" variant="outline" onClick={() => (dirty ? setAsk(true) : open())} data-testid="view-as-student-btn">
        <Eye className="w-4 h-4 mr-1.5" />Ver como alumno
      </Button>
      <AlertDialog open={ask} onOpenChange={setAsk}>
        <AlertDialogContent className="w-[calc(100vw-2rem)] max-w-md" data-testid="unsaved-preview-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Tienes cambios sin guardar</AlertDialogTitle>
            <AlertDialogDescription>El perfil público muestra la última versión guardada.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={open} data-testid="view-without-saving-btn">Ver sin guardar</AlertDialogCancel>
            <AlertDialogAction onClick={saveAndView} data-testid="save-and-view-btn">Guardar y ver</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
